(() => {
  if (window.FourPawCartCopy) return;

  const apply = (root = document) => {
    const settings = window.FourPawCartCopySettings || {};
    const replacementCopy = [settings.freeShippingDetail, settings.guaranteeDetail];
    root.querySelectorAll('.fp-cart-reference-benefit__copy small').forEach((element, index) => {
      const copy = replacementCopy[index];
      if (copy && element.textContent.trim() !== copy) element.textContent = copy;
    });
    root.querySelectorAll('.fp-cart-savings-row > span').forEach((element) => {
      if (settings.savingsLabel && element.textContent.trim() !== settings.savingsLabel) {
        element.textContent = settings.savingsLabel;
      }
    });
    root.querySelectorAll('.fp-cart-reference-summary__label small').forEach((element) => {
      if (settings.footerText && element.textContent.trim() !== settings.footerText) {
        element.textContent = settings.footerText;
      }
    });
  };

  let frame = 0;
  const schedule = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => apply());
  };

  const cartMutation = (record) => {
    const selector = 'cart-drawer, #main-cart-footer, .fp-cart-reference-benefit__copy, .fp-cart-savings-row, .fp-cart-reference-summary__label';
    if (record.target?.matches?.(selector) || record.target?.closest?.('cart-drawer, #main-cart-footer')) return true;
    return [...record.addedNodes, ...record.removedNodes].some((node) => node instanceof Element && (
      node.matches(selector) || node.querySelector(selector)
    ));
  };

  const start = () => {
    apply();
    new MutationObserver((records) => {
      if (records.some(cartMutation)) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:block:select', schedule);

  window.FourPawCartCopy = { apply };
})();
